import { render, staticRenderFns } from "./inbox.vue?vue&type=template&id=482a054d&scoped=true"
import script from "./inbox.vue?vue&type=script&lang=js"
export * from "./inbox.vue?vue&type=script&lang=js"
import style0 from "./inbox.vue?vue&type=style&index=0&id=482a054d&prod&scoped=true&lang=css"
import style1 from "./inbox.vue?vue&type=style&index=1&id=482a054d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482a054d",
  null
  
)

export default component.exports